import { Formik, FormikHelpers } from "formik";
import {
  HeaderSaveFormButton,
  ReportingMelcoMachineStatisticsModelsGroupListItem,
  useFormSubmit,
} from "melco-shared-logic";
import { useMachineStatusViewEdit } from "../../../hooks/reporting/useMachineStatusViewEdit";
import { useMachineStatusViewAdd } from "../../../hooks/reporting/useMachineStatusViewAdd";
import { DisplayMachineStatusViewDetailForm } from "./DisplayMachineStatusViewDetailForm ";
import { DirtyFormPrompt } from "../../form/DirtyFormPrompt";
import { useNavigate, useParams } from "react-router";
import { useState } from "react";
import LoadingDefaultSpinIndicator from "../../loading/LoadingDefaultSpinIndicator";

export type MachineStatusViewDetailFormValueType = {
  name: string;
  id: string;
  group_list?: Array<ReportingMelcoMachineStatisticsModelsGroupListItem> | null;
  grouped_display: boolean;
  submitAction: string;
};

const machineStatusViewToInitialValues = (statusView: any | undefined) => {
  const { name, id, group_list, grouped_display, submitAction } = statusView
    ? statusView
    : {
        name: "",
        id: "",
        group_list: [],
        grouped_display: false,
        submitAction: "view",
      };

  const initialValues: MachineStatusViewDetailFormValueType = {
    name: name ?? "",
    id: id ?? "",
    group_list: group_list ?? [],
    grouped_display: grouped_display ? true : false,
    submitAction: submitAction ?? "view",
  };
  return initialValues;
};

type MachineStatusViewDetailFormProps = {
  machineStatusView?: any | undefined;
};

export const StatusViewDetailForm: React.FC<
  MachineStatusViewDetailFormProps
> = ({ machineStatusView }) => {
  const { viewId } = useParams<{ viewId: string }>();
  const initialValues = machineStatusViewToInitialValues(machineStatusView);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const editMachineStatusView = useMachineStatusViewEdit();
  const addMachineStatusView = useMachineStatusViewAdd();

  const onHandleSubmit = useFormSubmit<MachineStatusViewDetailFormValueType>(
    async (
      values: MachineStatusViewDetailFormValueType,
      formikHelpers: FormikHelpers<MachineStatusViewDetailFormValueType>
    ) => {
      if (machineStatusView && machineStatusView.id) {
        const newEntity = await editMachineStatusView(values);

        formikHelpers.resetForm({
          values: machineStatusViewToInitialValues(newEntity),
        });
      } else {
        const newEntity = await addMachineStatusView(values);
        // reset the form to avoid the dirty condition otherwise pop up
        // will display , do you want to leave the page
        formikHelpers.resetForm({ values: initialValues });
        // time out to get time to reset the form
        setTimeout(() => {
          // navigate to edit page to open the newly created view in edit mode
          navigate("/reporting/machine/status/views/" + newEntity?.id);
        }, 1000);
      }
    },
    {
      translationPrefix: "",
    }
  );

  if (!machineStatusView && !(viewId === "new")) {
    return null;
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values, formikHelpers) =>
        onHandleSubmit(values, formikHelpers, {
          isManuallyResettingForm: true,
        })
      }
    >
      <>
        <DirtyFormPrompt>
          <LoadingDefaultSpinIndicator isShown={isLoading}>
            <DisplayMachineStatusViewDetailForm />
            <HeaderSaveFormButton />
          </LoadingDefaultSpinIndicator>
        </DirtyFormPrompt>
      </>
    </Formik>
  );
};
